import { Injectable } from '@angular/core';
import { VisaTypes } from '../employees/domain/visa-types';
import { environment } from '../../../environments/environment';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class VisaTypeService {
  private visasRefresh = new BehaviorSubject<void>(undefined);
  private visasRefresh$ = this.visasRefresh.asObservable();

  readonly allWithRemovedOrUsedVisas$: Observable<VisaTypes[]> = this.visasRefresh$.pipe(
    switchMap(() => this.http.get<VisaTypes[]>(`${environment.api}/visa-type`)),
    map(visas => visas.map(visa => ({
      ...visa,
      name: visa.isRemoved ? `${visa.name} (Removed)` : visa.name
    }))),
    shareReplay(1),
  );

  readonly currentVisas$: Observable<VisaTypes[]> = this.allWithRemovedOrUsedVisas$.pipe(
      map((visas) => visas.filter((visa) => !visa.isRemoved)),
  );

  constructor(private http: HttpClient) {}

  refreshVisas(): void {
    this.visasRefresh.next();
  }

  addVisa(newVisa: VisaTypes): Observable<{ msg:string }> {
    return this.http.post<{ msg:string }>(`${environment.api}/admin/visa-type`, newVisa);
  }

  editVisa(visaId: number, editedVisa: VisaTypes): Observable<{}> {
    return this.http.put(`${environment.api}/admin/visa-type/${visaId}`, editedVisa);
  }

  removeVisa(visaId: number): Observable<{}> {
    return this.http.delete(`${environment.api}/admin/visa-type/${visaId}`);
  }
}
